'use strict';

var shallowEqual$1 = require('../../../../_virtual/shallowEqual.js_commonjs-exports.js');

Object.defineProperty(shallowEqual$1.__exports, "__esModule", {
  value: true
});
var shallowEqual = function shallowEqual(a, b) {
  var keysA = Object.keys(a);
  var keysB = Object.keys(b);

  return keysA.length === keysB.length && keysA.every(function (key) {
    return b.hasOwnProperty(key) && b[key] === a[key];
  });
};

shallowEqual$1.__exports.default = shallowEqual;
